import { generateErrors } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/sap';
import { callApiPost, callApiV3Put } from 'utilities/apiCaller';
import API from 'constants/api';
import { CONFIG } from 'configs/index';
import { TransportMode } from 'constants/modes';
export const resetPDF = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.RESET_PDF.PENDING });
    }
};
export const generatePDF = (DocumentNumber: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_PDF.PENDING });
        try {
            const res = await callApiPost(`${API.SAP.GetPdf}`, {
                Type: 'Customer',
                I_Call_Browser: 'X',
                DocumentNumber
            }, { headers: { TransportMode: TransportMode.Ocean, 'Consumer-Key': CONFIG.consumerKey } });
            dispatch({ type: TYPES.FETCH_PDF.FULFILLED, pdf: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_PDF.REJECTED, errors });
        }
    }
};

export const resendLatestMessage = (documentId: string, itemType: 'FCR' | 'ETS' | 'Invoice' | 'CreditNote' | 'ExportJob' | 'EXPORTSALESORDER', finOpsStatus: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.RESEND_MESSAGE.PENDING });
        try {
            const res = await callApiV3Put(`${API.SAP.ResendMessage}/${documentId}`, {
                itemType,
                status: finOpsStatus
            }, { headers: { TransportMode: TransportMode.Ocean, 'Consumer-Key': CONFIG.consumerKey } });
            dispatch({ type: TYPES.RESEND_MESSAGE.FULFILLED, resendResponse: res.data });

        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.RESEND_MESSAGE.REJECTED, errors });
        }
    }
};